'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageContainer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'container': 'ccl-d523c73794f30c03',
  'default': 'ccl-917a4d5b8cd3a9e3',
  'fullWidthMobileOnly': 'ccl-c8c1894afe6a7a96',
  'largeMaxWidth': 'ccl-720f2f4d3d7a267f',
  'xLargeMaxWidth': 'ccl-af374307f9a1e378',
  'xxLargeMaxWidth': 'ccl-71fbf9dc5f85ebd4',
  'fullWidthAlways': 'ccl-bc110767f78f5516'
};

/**
 * Allows you to get the correct horizontal padding and max-width for top-level elements on pages.
 */

function PageContainer(props) {
  var _classnames;

  var classes = (0, _classnames3.default)(styles.container, (_classnames = {}, _defineProperty(_classnames, styles.default, props.fullWidth === null), _defineProperty(_classnames, styles.fullWidthMobileOnly, props.fullWidth === 'mobile-only'), _defineProperty(_classnames, styles.fullWidthAlways, props.fullWidth === 'always'), _defineProperty(_classnames, styles.largeMaxWidth, props.maxWidth === 'large'), _defineProperty(_classnames, styles.xLargeMaxWidth, props.maxWidth === 'x-large'), _defineProperty(_classnames, styles.xxLargeMaxWidth, props.maxWidth === 'xx-large'), _classnames));

  return _react2.default.createElement(
    'div',
    { className: classes },
    props.children
  );
}

PageContainer.displayName = 'PageContainer';
PageContainer.propTypes = {
  /**
   * Configures when the contents of the PageContainer should be full-width, if provided.
   *
   * `always` means that irrespective of break-point it will always be full-width. This is useful for full-width elements such as background-images etc.
   *
   * `mobile-only` means that the container will only ever be full-width on mobile.
   */
  fullWidth: _propTypes2.default.oneOf(['mobile-only', 'always']),
  /**
   * Sets the max width of the container
   *
   * default: 1120px
   * large: 1440px
   * x-large: 1920px
   * xx-large: 2560px
   */
  maxWidth: _propTypes2.default.oneOf(['default', 'large', 'x-large', 'xx-large']),

  children: _propTypes2.default.node.isRequired
};

PageContainer.defaultProps = {
  fullWidth: null,
  maxWidth: 'default'
};